import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, App, AlertController, ToastController } from 'ionic-angular';
import { Seva } from '../../models/Seva';
import { ExportToCSV } from '../../models/ExportToCSV';
import { TableReport } from '../../models/TableReport';
import { RestProvider } from '../../providers/rest/rest';
import { DatePipe } from '@angular/common';
import { User, Categories } from '../../models/User';
import { Gotra } from '../../models/Gotra';
import { Nakshatra } from '../../models/Nakshatra';
import { SevaData } from '../../models/SevaData';
import { AdminPage } from '../admin/admin';
import { SevaBookingResponse } from '../../models/SevaBookingResponse';
import { PostSevaBooking } from '../../models/PostSevaBooking';
import { DeleteReport } from '../../models/deletereport';
import { Japa } from '../../models/japa';



@IonicPage()
@Component({
  selector: 'page-admin-next',
  templateUrl: 'admin-next.html',
})
export class AdminNextPage implements OnInit{
type_selected:string;

//report variables
  start_date = new Date().toISOString();
  end_date = new Date().toISOString();
  seva_array: Seva[] = [];
  //exporter = new ExportToCSV();
  TablePopulated:boolean = false;
  DataArray:any;
  CashArray:any;
  ChequeArray:any;
  CardArray:any;
  TableDataForDisplay:TableReport[];
  RowTotal:number = 0;

  //reciept variables
  reciept_number:string;
//display fields
reciept_name:string;
reciept_phone:number;
reciept_gotra:string;
reciept_nakshatra:any;
reciept_sevadate:any;
reciept_sevatime:string;
reciept_token:any;
reciept_special:string;
reciept_paytype:string;
reciept_paynote:string;
reciept_total:number;
reciept_id:number;
reciept_extrapersons:number;
reciept_data:SevaBookingResponse;

  //user variables
  user_mobile_number:any;
user_name:string;
email:string;
user_password:string;
gotra:string;
nakshatra:any;
user_array:User[] = [];
gotra_array: Gotra[];
  nakshatra_array: Nakshatra[];
  show_gotra_array: boolean = false;
show_nakshatra_array: boolean = false;
show_user_list:boolean = false;
selected_user:User;
veda:string;

//new variables
stype:string;
today:any;

//user var
user_active:number = 1;
regular_access:boolean = true;
special_access:boolean = true;
aradhane_access:boolean = true;
building_fund_access:boolean = true;
self_access:boolean = false;
all_access:boolean = false;
user_categories:string[];
user_categories_sending:Categories[] = [];
report_access:any;

//seva var
Sections_array:string[] = [];
Category_array:string[] = [];
show_sections:boolean = false;
show_category:boolean = false;
sevas:Seva[] = [];

//R&R
fromdateseva:any;
todateseva:any;
Rsection:string;
pdf_for:string;
delete_reason;
showdeletebutton:boolean = false;
exporter = new ExportToCSV();

//JAPA VARIABLES
japa_name:string;
japa_active:number=1;
japa_array:Japa[] = [];
selected_japa:Japa;

constructor(public navCtrl: NavController, public navParams: NavParams,private restProvider: RestProvider, public appCtrl: App, private alertController:AlertController, private datePipe: DatePipe,private toastCtrl:ToastController) {
  }

  ngOnInit()
  {
    this.type_selected = this.navParams.get('data');
    console.log("type_selected:",this.type_selected);
    this.today = new Date()
    this.today = this.datePipe.transform(this.today, "yyyy-MM-dd");
    console.log("today:",this.today)
    if(this.navParams.get('stype'))
    {
      this.stype = this.navParams.get('stype')
      console.log("stype from new seva screen",this.stype)
    }
    else
    {
      this.stype = 'user';
      this.selectedUser(); //commenting for now as it has huge data
    }
    //report
    this.DataArray = [];
    this.CashArray = [];
    this.CardArray = [];
    this.ChequeArray = [];
    this.TableDataForDisplay = [];
    this.TablePopulated = false;

    //user
    this.user_array = [];
    this.user_categories = [];
    this.user_categories_sending = [];
    this.gotra_array = [];
    this.nakshatra_array = [];

    this.restProvider.getSevaData()
  .subscribe(
    (result: SevaData) => {
      console.log(result);
      if (result) {
        this.gotra_array = result.gotras;
         //console.log(this.gotra_array)
        this.nakshatra_array = result.nakshatras;
         //console.log(this.nakshatra_array)
         this.sevas = result.sevas;
         console.log("sevas",this.sevas);
   }
    },
    error => {
      console.log(error);
    }
  )
  //new

  this.Sections_array = ['REGULAR','SPECIAL','ARADHANA','BUILDING FUND','ALL'];
  this.Category_array = ['REGULAR','HUNDI','ARADHANA','SEASONAL','SWAMIJIGALU','BUILDING FUND','OTHERS'];

  }

//new design functionalities
selectedUser()
{
  this.stype = "user";
  console.log("stype:",this.stype)
  this.user_categories = [];
this.restProvider.ShowAllUsersForAdmin().subscribe(
  (result) => {
    console.log("result from ShowAllUsersForAdmin()",result)
   this.user_array = result;

   for(let i = 0; i < this.user_array.length; i++)
   {
    this.user_categories[i] = "";
    for(let t = 0; t < this.user_array[i].categories.length; t++)
      this.user_categories[i] = this.user_categories[i] + this.user_array[i].categories[t].description + " ";
      console.log("user categories",this.user_categories[i]);
   }

    console.log("users:",this.user_array);
    console.log("user categories",this.user_categories);




  },
  error => {
    console.log(error);
  }
);
}
selectedSeva()
{
this.stype = "seva";
console.log("stype:",this.stype)
console.log("sevas:",this.sevas);



}
selectedR()
{
  this.stype = "R";
  console.log("stype:",this.stype)
}
selectedJapa()
{
  this.stype = "Japa";
  console.log("stype",this.stype);
  this.restProvider.ShowAllJapasForAdmin().subscribe(
    (result) => {
      console.log("result from ShowAllJapasForAdmin()",result)
     this.japa_array = result;
    
  
      console.log("users:",this.japa_array);
    },
    error => {
      console.log(error);
    }
  );
}
SaveJapa()
{
  let japaobj = new Japa();
  japaobj.id = ((this.selected_japa)? this.selected_japa.id :null);
  japaobj.japa_name = this.japa_name;
  japaobj.is_active =((this.japa_active) ? 1 : 0);
  console.log("japaobj before passing",japaobj);
  if(japaobj != null)
  {
    this.restProvider.updateJapa(japaobj).subscribe((result) => {
      console.log(result);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Saved successfully',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      this.selectedJapa();

      this.japa_name = null;
      this.selected_japa = null;
      this.japa_active = 1;

    }
   ,error => {
  console.log("error from japa post api",error);
  let alert = this.alertController.create({
    title: 'Alert',
    subTitle: 'Not saved.Please try again.',
    enableBackdropDismiss:false,
    cssClass: 'buttonCss',
    buttons: [
      {
        text: 'Ok',
        cssClass: 'buttonCss',
        role: 'cancel',
        handler: () => {
        }
      }
    ]
  });

  alert.present();
   }
   );
  }
}
EditJapa(j)
{
  //this.user_categories =  [];
this.regular_access = false;
//this.special_access = false;
this.aradhane_access = false;
this.building_fund_access = false;
//user_categories =[{}];
console.log("japa selected:",j)
if(j)
{
this.selected_japa = j;
this.japa_name = j.japa_name;
this.japa_active = j.is_active;
}
}
showSectionsList()
{
  this.show_sections = true;

}
setSection(s:any)
{
this.Rsection = s;
this.show_sections = false;

}
showCategoryList()
{
this.show_category = true;
}
onKeyPress(event) {
  if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
      return true
  }
  else {
      return false
  }
}
EditUser(u:User)
{
  //let user_categories:Categories[];
//this.user_categories =  [];
this.regular_access = false;
  //this.special_access = false;
  this.aradhane_access = false;
  this.building_fund_access = false;
//user_categories =[{}];
  console.log("user selected:",u)
  if(u)
  {
    this.selected_user = u;
this.user_name = u.name;
this.user_mobile_number = u.phone;
this.user_active = u.is_active;
if(u.user_role == 1)
{
  this.report_access = 'self_access' ;
}
else
{
  this.report_access = 'all_access' ;

}
//this.user_categories = u.categories;
console.log(this.user_categories);
let searchregularcategory = u.categories.find((item)=> item.description == "REGULAR");
if(searchregularcategory)
{
  this.regular_access = true;
}
// let searchspecialcategory = u.categories.find((item)=> item.description == "SPECIAL");
// if(searchspecialcategory)
// {
//   this.regular_access = true;
// }
let searcharadhanacategory = u.categories.find((item)=> item.description == "ARADHANA");
if(searcharadhanacategory)
{
  this.aradhane_access = true;
}
let searchbuildingfundcategory = u.categories.find((item)=> item.description == "BUILDING FUND");
if(searchbuildingfundcategory)
{
  this.building_fund_access = true;
}


}
}

//delete user
OnDeleteUser(d:User)
{
  console.log("user selected for deleting:",d);
}

 //save
 OnSaveUser()
 {
  console.log("user editing",this.selected_user)
  let userobj = new User();
  //let user_categories=[] ;
  // let user_categories:Categories[] ;
  let user_categories:any ;
  userobj.id = ((this.selected_user)? this.selected_user.id :null);
  //userobj.user_role = ((this.selected_user)? null :1);
  userobj.name = this.user_name;
  userobj.password = this.user_password;
  userobj.phone = this.user_mobile_number;
  userobj.is_reset_password = 1;
  userobj.is_active =((this.user_active) ? 1 : 0);
  userobj.veda =(this.veda);
  if(this.selected_user)
  {
    this.selected_user.categories = [];
    this.user_categories_sending = [];
  }
  if(this.regular_access == true)
  {
    //this.user_categories_sending = [];
    this.user_categories_sending.push({seva_category_id:1,description:"REGULAR"});
    this.user_categories_sending.push({seva_category_id:2,description:"SPECIAL"});
  }
  // if(this.special_access == true)
  // {
  //   //this.user_categories_sending = [];
  //   this.user_categories_sending.push({seva_category_id:2,description:"SPECIAL"});
  // }
  if(this.aradhane_access == true)
  {
    //this.user_categories_sending = [];
    this.user_categories_sending.push({seva_category_id:3,description:"ARADHANA"});
  }
  if(this.building_fund_access == true)
  {
    //this.user_categories_sending = [];
    this.user_categories_sending.push({seva_category_id:4,description:"BUILDING FUND"});
  }
  console.log("user categories passing:",this.user_categories_sending)
  userobj.categories = this.user_categories_sending;
  if(userobj.categories.length == 0)
  {
    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Please select the  billing access for the user',
      enableBackdropDismiss:false,
      cssClass: 'buttonCss',
      buttons: [
        {
          text: 'Ok',
          cssClass: 'buttonCss',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    alert.present();
    return;
  }
//   if(this.regular_access)
//   {
//     if(this.selected_user)
//     {
//       console.log("editing the user")
//       let w:any;
//       console.log(this.selected_user.categories)
//       w = this.selected_user.categories.find((item) => {return item.description == 'REGULAR'})
//       if(w)
//       {
//         console.log("already we have regular category",w);
//         this.user_categories_sending = this.selected_user.categories;
//       }
//       if(!w)
//       {

//         this.user_categories_sending.push({seva_category_id:1,description:"REGULAR"});
//       }

//     }
// else
//     {
//       console.log("came inside else block")
//       this.user_categories_sending.push({seva_category_id:1,description:"REGULAR"});
//     }

//   }
//   if(this.special_access)
//   {
//     if(this.selected_user)
//     {
//       let x:any;
//       console.log(this.selected_user.categories)
//       x = this.selected_user.categories.find((item) => {return item.description == 'SPECIAL'})
//       if(x)
//       {
//         console.log("already we have special category",x);
//         this.user_categories_sending = this.selected_user.categories;
//       }
//       if(!x)
//       {

//         this.user_categories_sending.push({seva_category_id:2,description:"SPECIAL"});
//       }


//   }
// }
//   if(this.aradhane_access)
//   {
//     if(this.selected_user)
//     {
//       let y:any;
//       console.log(this.selected_user.categories)
//       y = this.selected_user.categories.find((item) => {return item.description == 'ARADHANA'})
//       if(y)
//       {
//         console.log("already we have aradhana category",y);
//         this.user_categories_sending = this.selected_user.categories;
//       }
//       if(!y)
//       {

//         this.user_categories_sending.push({seva_category_id:3,description:"ARADHANA"});
//       }

//   }
// }
//   if(this.building_fund_access)
//   {
//     if(this.selected_user)
//     {
//       let z:any;
//       console.log(this.selected_user.categories)
//       z = this.selected_user.categories.find((item) => {return item.description == 'BUILDING FUND'})
//       if(z)
//       {
//         console.log("already we have aradhana category",z);
//         this.user_categories_sending = this.selected_user.categories;
//       }
//       if(!z)
//       {

//         this.user_categories_sending.push({seva_category_id:4,description:"BUILDING FUND"});
//       }

//     }
// else
//     {
//       this.user_categories_sending.push({seva_category_id:4,description:"BUILDING FUND"});
//     }

//   }

  userobj.user_role = (this.report_access == 'self_access') ? 1 : 2;
  console.log("user data before creating/updating:",userobj)
  if(userobj != null)
  {
    this.restProvider.updateUser(userobj).subscribe((result) => {
      console.log(result);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Saved successfully',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      this.selectedUser();

      this.user_name = null;
      this.user_mobile_number = null;
      user_categories = null;
      this.regular_access = null;
      this.special_access = null;
      this.aradhane_access = null;
      this.building_fund_access = null;
      this.self_access = null;
      this.all_access = null;

    }
   ,error => {
  console.log(error);
  let alert = this.alertController.create({
    title: 'Alert',
    subTitle: 'Not saved.Please try again.',
    enableBackdropDismiss:false,
    cssClass: 'buttonCss',
    buttons: [
      {
        text: 'Ok',
        cssClass: 'buttonCss',
        role: 'cancel',
        handler: () => {
        }
      }
    ]
  });

  alert.present();
   }
   );
  }

}

ResetPassword()
{
  if(this.selected_user)
  {
    this.selected_user.is_reset_password = 1;
    this.selected_user.password = null;
    console.log("object before passing",this.selected_user)

    let user_categories:any ;
  this.selected_user.id = ((this.selected_user)? this.selected_user.id :null);
  this.selected_user.user_role = ((this.selected_user)? null :1);
  this.selected_user.name = this.user_name;
  //this.selected_user.password = this.user_password;
  this.selected_user.phone = this.user_mobile_number;
  this.selected_user.is_reset_password = 1;
  this.selected_user.is_active =((this.user_active) ? 1 : 0);
  this.selected_user.categories = (this.user_categories_sending)? this.user_categories_sending : null;
  this.selected_user.user_role = (this.report_access == 'self_access') ? 1 : null;
    this.restProvider.updateUser(this.selected_user).subscribe((result) => {
      console.log("reset password result:",result);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Password reset successfull',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      this.selectedUser();
      this.user_name = null;
      this.user_mobile_number = null;
      //user_categories = null;
      this.regular_access = null;
      this.special_access = null;
      this.aradhane_access = null;
      this.building_fund_access = null;

    }
   ,error => {
  console.log(error);
  let alert = this.alertController.create({
    title: 'Alert',
    subTitle: 'Password reset unsuccessfull',
    enableBackdropDismiss:false,
    cssClass: 'buttonCss',
    buttons: [
      {
        text: 'Ok',
        cssClass: 'buttonCss',
        role: 'cancel',
        handler: () => {
        }
      }
    ]
  });

  alert.present();

   }
   );
  }

}

ShowReceipt()
{
  this.pdf_for = "BILL";
  if(this.reciept_number == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter reciept number',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
    if((this.reciept_number.trim()).length < 5 || (this.reciept_number.trim()).length > 5)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter last 5 digits of the reciept number for search',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
    console.log("reciept no:",this.reciept_number)
    this.restProvider.reprintPDF(this.reciept_number).subscribe(
      (res) => {

        console.log('res', res);
        if(res)
        {
          this.showdeletebutton = true;
        }
       // this.file.writeFile(this.file.externalApplicationStorageDirectory, 'statement.pdf', blob, { replace: true })

        //console.log(url);

        //var fileURL = URL.createObjectURL(res);

        //console.log(fileURL)
        //this.ClearAllFields();
        //window.open(fileURL);
       // window.localStorage.setItem("pdf",res)

       //trail
if(this.reciept_number)
{

  let modReceiptId = this.reciept_number.replace('/','_').replace('/','_');
  console.log("modified reciepno:",modReceiptId)
  //var url = "https://srmdev.qubesw.com/api/printreceipt/" + modReceiptId;
        // var url = "https://api.srmsn.org/api/printreceipt/" + modReceiptId;
        var url = this.restProvider.serverURL+"printreceipt/" + modReceiptId;
     // var url = "https://srmapi.qubesw.com/api/printreceipt/" + modReceiptId;
       //var rhinoStorage = localStorage.getItem("pdf")
       console.log("url",url)
        //var rhinoStorage = localStorage.getItem("rhino")
    var rhino = document.getElementById("rhino");
// if (rhinoStorage) {
//     // Reuse existing Data URL from localStorage
//     //rhino.setAttribute("src", rhinoStorage);
//     localStorage.removeItem("rhino");
// }
//else {
    // Create XHR and FileReader objects
    var xhr = new XMLHttpRequest(),
        fileReader = new FileReader();

    xhr.open("GET", url, true);
    console.log("url",url)
    // Set the responseType to blob
    xhr.responseType = "blob";

    xhr.addEventListener("load", function () {
        if (xhr.status === 200) {
            // onload needed since Google Chrome doesn't support addEventListener for FileReader
            fileReader.onload = function (event:any) {
                // Read out file contents as a Data URL
                if(event.target.result)
                {
                  var result = event.target.result;

                  // Set image src to Data URL
                  rhino.setAttribute("src", result);
                }

                // Store Data URL in localStorage
                try {
                    localStorage.setItem("rhino", result);
                }
                catch (e) {
                    console.log("Storage failed: " + e);
                }
            };
            // Load blob as Data URL
            fileReader.readAsDataURL(xhr.response);
        }
    }, false);
    // Send XHR
    xhr.send();
//}



}
      },
      error => {
        console.log(error);
        if(error.status == 404)
        {
          var rhino = document.getElementById("rhino");
          if(rhino)
          {
            rhino.setAttribute('src',null)
          }
          let alert = this.alertController.create({
            title: 'Alert',
            subTitle: 'Result not found',
            enableBackdropDismiss:false,
            cssClass: 'buttonCss',
            buttons: [
              {
                text: 'Ok',
                cssClass: 'buttonCss',
                role: 'cancel',
                handler: () => {
                }
              }
            ]
          });

          alert.present();

          return
        }


      }


    );
    //localStorage.removeItem('rhino');
}


Addnewseva(obj:Seva)
{
  console.log("obj:",obj)
  if(obj)
  {
    this.navCtrl.push(AdminPage,{sevaforedit:obj,stype:this.stype});

  }
  else
  {
    this.navCtrl.push(AdminPage,{stype:this.stype});
  }
}
EditSeva(s:Seva)
{
  console.log("seva passed:",s)
if(s)
{
  this.Addnewseva(s);
}
}
DetailedCSV()
{
  //function need to be implemented
  this.pdf_for ="DETAILED_CSV";
  let fromdate = this.datePipe.transform(this.fromdateseva,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todateseva,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.csvReport(fromdate,todate,0).subscribe(
      (result:any) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
         
          let x = this.datePipe.transform(this.fromdateseva,'dd-MMM-yyyy');
          let y = this.datePipe.transform(this.todateseva,'dd-MMM-yyyy');
          console.log("fromdateseva,todateseva",x,y)
          let filename:string = 'sevabookings-' +x + '-' +y +'.csv';
          console.log("filename",filename)

              if(result.data.length > 0){
        this.exporter.exportAllToCSV(result.data, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
        }
        
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
    // this.exporter.exportAllToCSV(this.sevas, "Sevas.csv");

}
ShowDeletedReports()
{
  if(this.fromdateseva == null || this.todateseva == null)
  {
    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Please enter the dates',
      enableBackdropDismiss:false,
      cssClass: 'buttonCss',
      buttons: [
        {
          text: 'Ok',
          cssClass: 'buttonCss',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    alert.present();

    return
  }
  //function need to be implemented
  let fromdate = this.datePipe.transform(this.fromdateseva,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todateseva,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
  this.restProvider.ShowDeletedReports(fromdate,todate)
  .subscribe(
    (res) => {
      if(res)
      {
         //var url = "https://srmdev.qubesw.com/api/deletedreceipt?" + "start_date=" + fromdate + "&end_date=" + todate ;
        //  var url = "https://api.srmsn.org/api/deletedreceipt?" + "start_date=" + fromdate + "&end_date=" + todate ;
        var url = this.restProvider.serverURL+"deletedreceipt?" + "start_date=" + fromdate + "&end_date=" + todate ;
       // var url = "https://srmapi.qubesw.com/api/deletedreceipt?" + "start_date=" + fromdate + "&end_date=" + todate ;
        //var rhinoStorage = localStorage.getItem("pdf")
        console.log("url",url)
         //var rhinoStorage = localStorage.getItem("rhino")
     var rhino = document.getElementById("rhino");
 // if (rhinoStorage) {
 //     // Reuse existing Data URL from localStorage
 //     //rhino.setAttribute("src", rhinoStorage);
 //     localStorage.removeItem("rhino");
 // }
 //else {
     // Create XHR and FileReader objects
     let token = localStorage.getItem("token")
     var xhr = new XMLHttpRequest(),
         fileReader = new FileReader();


     xhr.open("GET", url, true);
     xhr.setRequestHeader('Authorization', 'Bearer ' + token);
     console.log("url",url)
     // Set the responseType to blob
     xhr.responseType = "blob";

     xhr.addEventListener("load", function () {
         if (xhr.status === 200) {
             // onload needed since Google Chrome doesn't support addEventListener for FileReader
             fileReader.onload = function (event:any) {
                 // Read out file contents as a Data URL
                 if(event.target.result)
                 {
                   var result = event.target.result;

                   // Set image src to Data URL
                   rhino.setAttribute("src", result);
                 }

                 // Store Data URL in localStorage
                 try {
                     localStorage.setItem("rhino", result);
                 }
                 catch (e) {
                     console.log("Storage failed: " + e);
                 }
             };
             // Load blob as Data URL
             fileReader.readAsDataURL(xhr.response);
         }
     }, false);
     // Send XHR
     xhr.send();
      }

    },
    error => {
        console.log(error)
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
    }
  );




}

//Function for deleting the reciept
OnDelete()
{
//alert for empty reciept number
if(this.reciept_number == null)
{
 let alert = this.alertController.create({
   title: 'Alert',
   subTitle: 'Please enter the reciept number to delete',
   enableBackdropDismiss:false,
   buttons: ['OK']
 });

 alert.present();
}
else if((this.reciept_number.trim()).length < 5 || (this.reciept_number.trim()).length > 5)
{
  let alert = this.alertController.create({
    title: 'Alert',
    subTitle: 'Please enter the last 5 digits of the reciept number to delete',
    enableBackdropDismiss:false,
    buttons: ['OK']
  });

  alert.present();
  return;
}
else
{
//Conformation Alert

let alert1 = this.alertController.create({
   title: 'Alert',
   subTitle: 'Are you sure you want to delete the reciept?',
   cssClass: 'buttonCss',
   buttons: [
     {
       text:'No',
       cssClass: 'nobutton',
       role:'Cancel',
       handler: () => {
         //console.log('Cancel clicked');
       }
     },
     {
       text:'Yes',
       cssClass: 'yesbutton',
       handler: () => {
         //console.log('Yes clicked');
         this.DisplayReasonAlert();

       }
      }
        ]
      })
      alert1.present();

}

}
DisplayReasonAlert()
{
  let alert2 = this.alertController.create({
    title: 'Alert',
subTitle: 'Please enter the reason for deleting',
cssClass: 'buttonCss',
    inputs: [
      {
        name: 'delete_reason',
        placeholder: 'Please enter the reason',
        type: 'text',
        //step:'1'

      },

    ],
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'nobutton',
        handler: data => {
          console.log('Cancel clicked');

        }
      },
      {
        text: 'Ok',
        cssClass: 'yesbutton',
        handler: data => {
          console.log("deleting reason:",data.delete_reason)
          this.delete_reason = data.delete_reason
          if(this.delete_reason)
      {
        let deleteparam = new DeleteReport();
        let modReceiptId = this.reciept_number.replace('/','_').replace('/','_');
        console.log("modified recieptno for deleting:",modReceiptId)
        deleteparam.id = modReceiptId;
        // deleteparam.reason = this.delete_reason;
        deleteparam.reason = this.delete_reason;
        console.log("reciept no",deleteparam);
        this.restProvider.DeleteSevaBooking(deleteparam)
        .subscribe(
          (res:any) => {
            console.log("delete result",res)
            if(res.message == "Deleted")
            {
              var rhino = document.getElementById("rhino");
              rhino.setAttribute("src",null)

               let alert = this.alertController.create({
                title: 'Alert',
                subTitle: 'Deleted Successfully.',
                enableBackdropDismiss:false,
                buttons: ['OK']
              });

              alert.present();
            }
            if(res.message == "Invalid Data")
            {
              let alert = this.alertController.create({
                title: 'Alert',
                subTitle: 'Not Found',
                enableBackdropDismiss:false,
                buttons: ['OK']
              });

              alert.present();
            }


          },
          error => {
           console.log(error);
           let alert = this.alertController.create({
            title: 'Alert',
            subTitle: 'Not deleted.Please try again',
            enableBackdropDismiss:false,
            buttons: ['OK']
          });

          alert.present();
          }
        );
      }


        }
      }
    ]
  })
  alert2.present();


}

ClearContent()
{
 this.reciept_name = null;
 this.reciept_phone = null;
 this.reciept_gotra = null;
 this.reciept_nakshatra = null;
 this.reciept_sevadate = null;
 this.reciept_sevatime = null;
 this.reciept_token = null;
 this.reciept_special = null;
 this.reciept_paytype = null;
 this.reciept_total = null;
 this.reciept_number = null;
}
Cancel()
{
  if(this.stype == "user")
  {
    this.user_name = null;
    this.user_mobile_number = null;
    this.user_active = null;
    this.regular_access = false;
    this.special_access = false;
    this.aradhane_access = false;
    this.building_fund_access = false;
    this.self_access = false;
    this.all_access = false;
    //this.user_categories = [];
    this.user_categories_sending = [];
    this.report_access = null;
  }
  if(this.stype == "seva")
  {

  }
  if(this.stype == "R")
  {
    this.fromdateseva = null;
this.todateseva = null;
this.Rsection = null;;
this.pdf_for = null;
this.delete_reason = null;
this.reciept_number = null;
  }
}

///////////////BELOW FUNCTIONS CORRESPONDS TO OLDER DESIGN /////////////////////////////////////////////////////////////////////////////

  //report functionalities
  OnGenerateReciept() {
    this.TableDataForDisplay= [];
    this.RowTotal = 0;

        // this.exporter.exportAllToCSV(this.seva_array, "SevaCSV");
        var strStartDate = this.start_date.slice(0.10);
        var strEndDate = this.end_date.slice(0.10);
         strStartDate = this.datePipe.transform(strStartDate,'yyyy-MM-dd');
         strEndDate = this.datePipe.transform(strEndDate,'yyyy-MM-dd');
        console.log("Target dates ", strStartDate, strEndDate, this.end_date);
        this.restProvider.getDailyReport(strStartDate, strEndDate)
        .subscribe(
          (res) => {

            console.log('res', res);
            this.TablePopulated = true;
            // var fileURL = URL.createObjectURL(res);
            // console.log(fileURL)
            // window.open(fileURL);
             this.CashArray = res.cash;
             this.CardArray = res.card;
             this.ChequeArray = res.cheque;

             let datearray:any;
             datearray = [];
             // let x = new TableReport;
            console.log("cash,card,cheque arrays:",this.CashArray,this.CardArray,this.ChequeArray)
             for (var d = new Date(this.start_date); d <= new Date(this.end_date); d.setDate(d.getDate() + 1))
             {

              let temp_date = this.datePipe.transform(d, "yyyy-MM-dd");
              console.log("Date after converting to required format",temp_date)
               //finding cash data for dates in dateArray
               let cash_data = this.CashArray.find((item)=> item.bookingdate == temp_date)
               console.log("matching cashdata",cash_data)
               //finding card data
               let card_data = this.CardArray.find((item)=> item.bookingdate == temp_date)
               console.log("matching carddata",card_data)
               let cheque_data = this.ChequeArray.find((item)=> item.bookingdate == temp_date)
               console.log("matching chequedata",cheque_data)

               datearray.push(temp_date);
             console.log(datearray.length)
             let x = new TableReport;
             x.b_date = temp_date;
             x.cash_amount = (cash_data)?cash_data.amount:0;
             x.card_amount = (card_data)?card_data.amount:0;
             x.cheque_amount = (cheque_data)?cheque_data.amount:0;
             this.TableDataForDisplay.push(x);

          }
           console.log("Dates Array",datearray)
           console.log("Table data:",this.TableDataForDisplay)
         },
          error => {
             console.log(error);
          }
        );

      }
      getRowSum(a:number,b:number,c:number)
      {
       this.RowTotal = a+b+c;
       return this.RowTotal;
      }

  //reciept functionalities
 //Function for serching and retrieving the data for the entered reciept number
 SerchRecieptData()
 {
   if(this.reciept_number == null)
   {
     let alert = this.alertController.create({
       title: 'Alert',
       subTitle: 'Please enter a reciept number, before searching',
       enableBackdropDismiss:false,
       buttons: ['OK']
     });

     alert.present();
   }
   else
   {
     this.restProvider.getReportDetails(this.reciept_number)
     .subscribe(result => {
      console.log(result);
      if(result)
      {
        //this.reciept_data = result;
        //this.reciept_name = result.name;
        //this.reciept_phone = result.phone;
        //this.reciept_gotra = result.gotra;
        //this.reciept_nakshatra = result.nakshatra;
        //this.sevadate = result.sevadate;
        //this.reciept_sevadate = this.datePipe.transform(result.sevadate, "yyyy-MM-dd");
        //this.reciept_sevatime = result.sevatime;
        //this.reciept_token = result.tokendetails;
        this.reciept_special = result.sevaspecialrequest;
        this.reciept_id = result.id;
        this.reciept_extrapersons = result.numpersons;

        this.reciept_paynote = result.paymentnote;

        if(result.paymenttype == "1")
        {
          this.reciept_paytype ="Cash";
        }
        else if(result.paymenttype == "2")
        {
          this.reciept_paytype ="Cheque";
        }
        else
        {
          this.reciept_paytype ="Card";
        }

        this.reciept_total = result.amounttotal;

        console.log(this.reciept_name,this.reciept_phone)


      }
    },
    error => {
      console.log(error);
      console.log(error.statusText);
      if(error.statusText == "Not Found" || error.status == 404)
      {
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Please enter  valid reciept number to search',
          enableBackdropDismiss:false,
          buttons: ['OK']
        });

        alert.present();
      }
      this.ClearContent();
    }
  );
 }  //end of else



 }


//reciept save
OnRecieptSave()
{
console.log("reciept:",this.reciept_data) //reciept_data is the reciept searched using search button
if(this.reciept_data)
{
  let postseva2 = new SevaBookingResponse;
  postseva2.id = this.reciept_data.id; //using the same id
  postseva2.name = this.reciept_name;
  postseva2.gotra = this.reciept_gotra;
  postseva2.nakshatra = this.reciept_nakshatra;
  postseva2.sevadate = this.reciept_sevadate;
  //postseva2.bookingtype =
  postseva2.amountpaid = this.reciept_total;
  postseva2.amountpending =this.reciept_data.amountpending;
  postseva2.tokendetails = this.reciept_token;
  postseva2.numpersons = this.reciept_extrapersons;
  //postseva2.bookingtype = '';
  postseva2.paymentnote = this.reciept_paynote;
  if(this.reciept_paytype.toUpperCase() == "CASH")
  {
    postseva2.paymenttype = "1";
  }
  if(this.reciept_paytype.toUpperCase() == "CHEQUE")
  {
    postseva2.paymenttype = "2";
  }
  if(this.reciept_paytype.toUpperCase() == "CARD")
  {
    postseva2.paymenttype = "3";
  }


  // this.restProvider.postSevaBooking(postseva2).subscribe(
  //   (result) => {
  //     console.log(result);
  //   },
  //   error => {
  //     console.log(error);
  //   }
  // );
  //postseva2.seva = this.reciept_data.sevas;

  //trying to edit the pdf
  //this.restProvider.updateReceipt(this.reciept_data.receiptno,postseva2).subscribe(
    // (result) => {

    //   if(result)
    //   {
        //console.log(result)
         this.restProvider.updateReceipt(this.reciept_data.receiptno,postseva2).subscribe(
           (result) => {

                console.log(result)
                if(result)
                {
                  //result.name = this.reciept_name;
                  //return new Blob([modres], { type: 'application/pdf', });

                }
                // var fileURL = URL.createObjectURL(result);
                //   console.log(fileURL)
                //   window.open(fileURL);

           },
           error => {
             console.log(error)
           }
         );
     // }

   // },
    // error => {
    // console.log(error);
    // }
 // );

}
}



 //user functionalities
 SearchWithPhoneNo() {
  if(this.user_mobile_number == null)
  {
    return;
  }
  if(this.user_mobile_number.length < 10)
  {
    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Invalid mobile number',
      enableBackdropDismiss:false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            console.log('Yes clicked');
          }
        }
      ]
    });
    alert.present();
    return;
  }
    //Calling method from rest service
    this.restProvider.searchUser(this.user_mobile_number)
      .subscribe(
        (result) => {
          console.log(result, result.length);
          if (result.length > 0) {
            this.user_array = result;
            this.user_mobile_number = result[0].phone;
            this.user_name = result[0].name; //All the records will have the same phone number, so set it to the first one.
            // TODO: THe following should be move to the dropdown selection 20180820

            // this.name = result[0].name;
            // this.gotra = result[0].gotra;
            // this.nakshatra = result[0].nakshatra;
          }
          else
          {
            let alert = this.alertController.create({
              title: 'Alert',
              subTitle: 'No result found',
              enableBackdropDismiss:false,
              buttons: [
                {
                  text: 'Ok',
                  handler: () => {
                    console.log('Yes clicked');
                  }
                }
              ]
            });
            alert.present();
          }
        },
        error => {
          console.log(error);
        }
      )
}
ShowExistingUser()
{
    this.show_user_list = true;
   console.log("arrow cliked",this.show_user_list)
}

//Function for selected user for entered phone number
SelectUser(d)
{
  console.log(d);
  this.selected_user = d;
  this.user_mobile_number = d.phone;
  this.user_name = d.name;
  this.gotra = d.gotra;
  this.nakshatra = d.nakshatra;
  this.show_user_list = false;
}

//Setting name
 SetName()
 {
   console.log("typing new name")
   this.show_user_list = false;
 }
  //Function for setting the selected gotra
  setgotra(gotra) {
    console.log(gotra);
    this.gotra = gotra;
    this.show_gotra_array = false;
  }


  //Function for setting selected nakshatra
  setnakshatra(nakshatra) {
    this.nakshatra = nakshatra;
    this.show_nakshatra_array = false;
  }

//recognizing whether the user clicks the gotra searchbar
  SearchbarPhoneActive() {
    console.log("inside serchbaractive")
    console.log(this.user_mobile_number);
    if (this.user_mobile_number != "") {
      this.show_user_list = true;
    }
    if(this.user_mobile_number.length == 10)
    {
      this.SearchWithPhoneNo()
    }

  }

  //recognizing whether the user clicks the gotra searchbar
  SearchbarGotraActive() {
    console.log("inside serchbaractive")
    console.log(this.gotra);
    if (this.gotra != "") {
      this.show_gotra_array = true;
    }


  }

  //recognizing whether the user clicks the nakshatra searchbar
  SearchbarNakshatraActive() {
    // console.log("inside serchbaractive")
    if (this.nakshatra != "") {
      this.show_nakshatra_array = true;
    }

  }
  //Function for blur event gotra
  SearchbarPhoneInactive() {
    // console.log("inside serchbargotrainactive")
    if (this.user_mobile_number == "") {
      this.show_user_list = false;
    }
    //this.show_gotra_array = false;

  }
  //Function for blur event gotra
  SearchbarGotraInactive() {
    // console.log("inside serchbargotrainactive")
    if (this.gotra == "") {
      this.show_gotra_array = false;
    }
    //this.show_gotra_array = false;

  }
  //Function for blur event nakshatra
  SearchbarNakshatraInactive() {
    // console.log("inside serchbarinactive")
    if (this.nakshatra == "") {
      this.show_nakshatra_array = false;
    }

  }



}



// WEBPACK FOOTER //
// ./src/pages/admin-next/admin-next.ts